import { render, staticRenderFns } from "./huangshiLoginForm.vue?vue&type=template&id=33742d9c&scoped=true"
import script from "./huangshiLoginForm.vue?vue&type=script&lang=js"
export * from "./huangshiLoginForm.vue?vue&type=script&lang=js"
import style0 from "./huangshiLoginForm.vue?vue&type=style&index=0&id=33742d9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33742d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33742d9c')) {
      api.createRecord('33742d9c', component.options)
    } else {
      api.reload('33742d9c', component.options)
    }
    module.hot.accept("./huangshiLoginForm.vue?vue&type=template&id=33742d9c&scoped=true", function () {
      api.rerender('33742d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/huangshiLoginForm.vue"
export default component.exports